/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Card,
  Input,
  Button,
  message,
  Typography,
  Space,
} from 'antd';
import {
  toUpper,
} from 'utils/normalizers';

import {
  generateCURPRules,
  generateRFCRules,
} from 'utils/rules';
import { digitoVerificador, digitoVerificadorRFC, claveHomonima } from 'utils/patterns';
import LecturaDeDocumento, { aplicarDatosDeDocumento } from 'components/LecturaDeDocumento/LecturaDeDocumento';
import { getCodigosPostales } from 'api/catalogos';
import Select from 'components/Select';
// import { getCodigosPostales } from 'api/catalogos';
// eslint-disable-next-line react/prop-types
const BecarioFiliacion = ({
  form,
  formFiliacion,
  tiposDeIdentificaciones,
  tiposDeSeguridadesSociales,
  registrosPatronales,
  isBlocked,
  disabled,
  codigosPostales,
  coloniasCargadas,
  preferenciaPartidaria,
}) => {
  const rules = {
    required: [{ required: true, message: 'Campo requerido' }],
    CURP: generateCURPRules({
      validateUnique: false,
      required: true,
      getter: () => Promise.resolve([]),
    }),
    RFC: [
      { required: true, message: 'El campo es requerido' },
      ...generateRFCRules({
        validateUnique: false,
      }),
    ],
    nombre: [
      {
        validator: async (_, value) => {
          const values = form.getFieldsValue();
          if (value && values.apellido_paterno && values.apellido_materno) {
            throw new Error('Debe ingresar mínimo dos campos referentes a nombre');
          }
        },
      },
    ],
    apellido_paterno: [
      {
        validator: async (_, value) => {
          const values = form.getFieldsValue();
          if (value && !values.nombre && !values.apellido_materno) {
            throw new Error('Debe ingresar mínimo dos campos referentes a nombre');
          }
        },
      },
    ],
    apellido_materno: [
      {
        validator: async (_, value) => {
          const values = form.getFieldsValue();
          if (value && !values.apellido_paterno && !values.nombre) {
            throw new Error('Debe ingresar mínimo dos campos referentes a nombre');
          }
        },
      },
    ],
  };
  const [disableNoSS, setDisableNoSS] = useState(true);
  const [mensajeVisible, setMensajeVisible] = useState(false);
  const [colonias, setColonias] = useState([]);

  const onChangeTipoSS = (val) => {
    formFiliacion.resetFields(['numero_de_seguridad_social']);
    setDisableNoSS(!val);
  };
  const clavesEstados = ['AS', 'BC', 'BS', 'CC', 'CL', 'CM', 'CS', 'CH', 'DF', 'DG', 'GT', 'GR', 'HG', 'JC', 'MC', 'MN', 'MS', 'NT', 'NL', 'OC', 'PL', 'QT', 'QR', 'SP', 'SL', 'SR', 'TC', 'TS', 'TL', 'VZ', 'YN', 'ZS', 'NE'];
  const ignoreListName = ['JOSE', 'MARIA', 'J', 'J.', 'MA', 'MA.'];
  const ignoreListConnectores = ['DA', 'DAS', 'DE', 'DEL', 'DER', 'DI', 'DIE', 'DD', 'EL', 'LA', 'LOS', 'LAS', 'LE', 'LES', 'MAC', 'MC', 'VAN', 'VON', 'Y'];
  const inconvenientes = ['BUEI', 'BUEY', 'CACA', 'CACO', 'CAGA', 'CAGO', 'CAKA', 'COGE', 'COJA', 'COJE', 'COJI', 'COJO', 'CULO', 'FETO', 'GUEY', 'JOTO', 'KACA', 'KACO', 'KAGA', 'KAGO',
    'KOGE', 'KOJO', 'KAKA', 'KULO', 'MAME', 'MAMO', 'MEAR', 'MEON', 'MION', 'MOCO', 'MULA', 'PEDA', 'PEDO', 'PENE', 'PUTA', 'PUTO', 'QULO', 'RATA', 'RUIN'];
  // const estado_nacimiento = Form.useWatch('estado_nacimiento', form);
  // const genero = Form.useWatch('genero', form);
  // const fecha_de_nacimiento = Form.useWatch('fecha_de_nacimiento', form);
  // const _nombre = Form.useWatch('nombre', form);
  // const _apellido_paterno = Form.useWatch('apellido_paterno', form);
  // const _apellido_materno = Form.useWatch('apellido_materno', form);
  const estado_nacimiento = form.getFieldValue('estado_nacimiento');
  const genero = form.getFieldValue('genero');
  const fecha_de_nacimiento = form.getFieldValue('fecha_de_nacimiento');
  const _nombre = form.getFieldValue('nombre');
  const _apellido_paterno = form.getFieldValue('apellido_paterno');
  const _apellido_materno = form.getFieldValue('apellido_materno');
  const [visibleNoSeCodigo, setVisibleNoSeCodigo] = useState(false);
  const composeCURP = () => {
    let curp;
    let rfc;

    const normalize = (t = '') => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/Ñ/g, 'X');
    const apellido_paterno_norm = normalize(_apellido_paterno);
    const apellido_materno_norm = normalize(_apellido_materno);
    const nombre_norm = normalize(_nombre);

    const nombres = nombre_norm.split(' ').filter((e) => e);
    if (ignoreListName.includes(nombres[0])) delete nombres[0];

    const removeConnectors = (a) => a.filter((e) => !ignoreListConnectores.includes(e))
      .join(' ').replace(/[-\\.\\/´¨]/g, 'X');

    const nombre = removeConnectors(nombres);
    const apellido_paterno = removeConnectors(apellido_paterno_norm.split(' '));
    const apellido_materno = removeConnectors(apellido_materno_norm.split(' '));

    const hasAllInfo = estado_nacimiento && genero && fecha_de_nacimiento && nombres.length;

    const curp17 = [
      apellido_paterno[0] || 'X',
      apellido_paterno.substr(1).replace(/[^aeiou]/gi, '')[0] || 'X',
      apellido_materno[0] || 'X',
      nombre[0] || 'X',

      fecha_de_nacimiento?.format('YYMMDD') || '000000',

      { 1: 'H', 2: 'M' }[genero] || 'X',

      clavesEstados[estado_nacimiento - 1] || 'XX',
      apellido_paterno.substr(1).replace(/[aeiou]/gi, '')[0] || 'X',
      apellido_materno.substr(1).replace(/[aeiou]/gi, '')[0] || 'X',
      nombre.substr(1).replace(/[aeiou]/gi, '')[0] || 'X',
      fecha_de_nacimiento && (parseInt(fecha_de_nacimiento.format('YYYY'), 10) < 2000 ? '0' : 'A'),
    ].filter((e) => e).join('');
    curp = curp17.replace(/Ñ/g, 'X');

    if (inconvenientes.includes(curp.substring(0, 4))) {
      curp = `${curp.substring(0, 1)}X${curp.substring(2)}`;
    }

    if (hasAllInfo) {
      curp = curp.concat(digitoVerificador(curp));
    }
    rfc = [
      apellido_paterno[0] || 'X',
      !apellido_paterno && 'X',
      apellido_paterno.length > 2 && (apellido_paterno.substr(1).replace(/[^aeiou]/gi, '')[0] || 'X'),
      apellido_materno && apellido_materno[0],
      nombre[0] || 'X',
      (apellido_paterno.length < 3 || !apellido_materno) && nombre[1],
      fecha_de_nacimiento?.format('YYMMDD') || '000000',
    ].filter((e) => e).join('');

    if (inconvenientes.includes(rfc.substring(0, 4))) {
      rfc = `${rfc.substring(0, 3)}X${rfc.substring(4)}`;
    }

    if (fecha_de_nacimiento && nombres.length) {
      const homoclave = claveHomonima([nombre, apellido_paterno, apellido_materno].join(' '));
      rfc = rfc.concat(homoclave);
      rfc = rfc.concat(digitoVerificadorRFC(rfc));
      // onsole.log(homoclave);
    }
    formFiliacion.setFieldsValue({ curp, RFC: rfc });

    if (!curp.includes('00') && !curp.includes('?')) {
      formFiliacion.validateFields(['CURP', 'RFC']);
    }
    setMensajeVisible(true);
  };

  // useEffect(() => {
  //   setColonias(coloniasCargadas);
  // }, [coloniasCargadas]);

  // const getFromPostalCode = (param) => {
  //   // setLoading(true);
  //   setTimeout(async () => {
  //     const _codigosPostales = await getCodigosPostales({ d_codigo: param });
  //     if (_codigosPostales.length) {
  //       const [firstItem] = _codigosPostales;
  //       const coloniasArr = _codigosPostales.map((item) => ({
  //         id: item.id, colonia: item.d_asenta,
  //       }));
  //       setColonias(coloniasArr);
  //       if (_codigosPostales.length === 1) {
  //         formFiliacion.setFieldsValue({
  //           pais_codigo_postal: 'México',
  //           codigo_postal: firstItem.d_codigo,
  //           colonia: firstItem.d_asenta,
  //           d_codigo: firstItem.d_codigo,
  //           estado: firstItem.municipio.estado.nombre_de_AGEE,
  //           municipio: firstItem.municipio.nom_mun,
  //         });
  //         // setFilteredColonies([firstItem]);
  //       } else {
  //         formFiliacion.setFieldsValue({
  //           pais_codigo_postal: 'México',
  //           codigo_postal: firstItem.d_codigo,
  //           d_codigo: firstItem.d_codigo,
  //           estado: firstItem.municipio.estado.nombre_de_AGEE,
  //           municipio: firstItem.municipio.nom_mun,
  //           colonia: firstItem.d_asenta,
  //         });
  //         // setFilteredColonies(_codigosPostales);
  //       }
  //     } else {
  //       message.info('No se encontro información relacionada al código postal brindado');
  //       formFiliacion.setFieldsValue({
  //         pais_codigo_postal: 'México',
  //         codigo_posta: undefined,
  //         d_codigo: undefined,
  //         estado: undefined,
  //         municipio: undefined,
  //         colonia: undefined,
  //       });
  //       // setFilteredColonies([]);
  //     }
  //   }, 300);
  //   // setLoading(false);
  // };
  const getFromPostalCode = (param) => {
    // setLoading(true);
    setTimeout(async () => {
      const _codigosPostales = await getCodigosPostales({ d_codigo: param });
      if (_codigosPostales.length) {
        const [firstItem] = _codigosPostales;
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        const estado = firstItem?.municipio?.estado?.nombre_de_AGEE || '';
        const municipio = firstItem?.municipio?.nom_mun || '';
        if (_codigosPostales.length === 1) {
          formFiliacion.setFieldsValue({
            pais_codigo_postal: 'México',
            colonia: firstItem.d_asenta,
            d_codigo: firstItem.d_codigo,
            estado,
            municipio,
          });
        } else {
          formFiliacion.setFieldsValue({
            pais_codigo_postal: 'México',
            d_codigo: firstItem.d_codigo,
            estado,
            municipio,
            colonia: firstItem.d_asenta,
          });
        }
      } else {
        message.info('No se encontro información relacionada al código postal brindado');
        formFiliacion.setFieldsValue({
          pais_codigo_postal: 'México',
          codigo_posta: undefined,
          d_codigo: undefined,
          estado: undefined,
          municipio: undefined,
          colonia: undefined,
        });
      }
    }, 300);
    // setLoading(false);
  };

  // 1. Vigilamos el campo del código postal
  const cp_fiscal = Form.useWatch('codigo_postal_fiscal_texto_libre', formFiliacion);

  // 2. Auto-completar Estado/Municipio al editar (el CP ya viene guardado pero
  // Estado/Municipio son campos derivados que no se persisten)
  useEffect(() => {
    if (cp_fiscal && cp_fiscal.length === 5) {
      const estadoActual = formFiliacion.getFieldValue('estado');
      const municipioActual = formFiliacion.getFieldValue('municipio');

      if (!estadoActual || !municipioActual) {
        getFromPostalCode(cp_fiscal);
      }
    }
  }, [cp_fiscal]);

  return (
    <Form
      layout="vertical"
      form={formFiliacion}
      scrollToFirstError
      name="general"
    >
      <Card
        size="small"
        className="inner-block-card"
      >
        <Typography.Text strong style={{ fontSize: 16 }}>
          {[
            form.getFieldValue('nombre'),
            form.getFieldValue('apellido_paterno'),
            form.getFieldValue('apellido_materno'),
          ].filter(Boolean).join(' ')}
        </Typography.Text>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="1. Identificación Oficial"
        extra="Documento De Identidad Y Claves Fiscales"
      >
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item>
              <Space wrap>
                <LecturaDeDocumento
                  tipo="CSF"
                  texto="Leer Constancia de Situación Fiscal"
                  disabled={isBlocked}
                  onDatos={(datos) => aplicarDatosDeDocumento('CSF', datos, formFiliacion, form, { tiposDeIdentificaciones })}
                />
                <LecturaDeDocumento
                  tipo="INE"
                  texto="Leer INE Frontal"
                  disabled={isBlocked}
                  onDatos={(datos) => aplicarDatosDeDocumento('INE', datos, formFiliacion, form, { tiposDeIdentificaciones })}
                />
                <LecturaDeDocumento
                  tipo="INE_REVERSO"
                  texto="Leer INE Reverso"
                  disabled={isBlocked}
                  onDatos={(datos) => aplicarDatosDeDocumento('INE_REVERSO', datos, formFiliacion, form, { tiposDeIdentificaciones })}
                />
              </Space>
            </Form.Item>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <Form.Item
              label="CURP"
              rules={rules.CURP}
              name="curp"
              normalize={toUpper}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <Form.Item
              label="RFC"
              // rules={rules.RFC}
              name="RFC"
              normalize={(val) => val?.toUpperCase()}
            >
              <Input
                allowClear
                disabled={disabled}
                maxLength={13}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_identificacion"
              label="Tipo de Identificación"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={tiposDeIdentificaciones}
                labelProp="nombre"
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="numero_de_identificacion"
              label="Numero de Identificación"
              rules={rules.no_identificacion}
              hasFeedback
            >
              <Input
                allowClear
                disabled={isBlocked}
                maxLength={11}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="Generar"
              label=" "
            >
              <Button
                onClick={composeCURP}
                disabled={isBlocked}
              >
                Generar CURP y RFC
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="2. Seguridad Social"
        extra="Régimen, NSS, SBC Y Registro Patronal"
      >
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item>
              <LecturaDeDocumento
                tipo="NSS"
                texto="Leer Constancia del IMSS"
                disabled={disableNoSS || isBlocked}
                onDatos={(datos) => aplicarDatosDeDocumento('NSS', datos, formFiliacion, form, { tiposDeIdentificaciones })}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="tipo_de_seguridad_social"
              // rules={rules.required}
              label="Tipo de Seguridad Social"
              hasFeedback
            >
              <Select
                dataSource={tiposDeSeguridadesSociales}
                labelProp="concepto"
                onChange={onChangeTipoSS}
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="numero_de_seguridad_social"
              rules={!disableNoSS ? rules.numero_de_seguridad_social : null}
              label="Numero de Seguridad Social"
              hasFeedback
            >
              <Input
                allowClear
                disabled={disableNoSS || isBlocked}
                maxLength={11}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="registro_patronal"
              // rules={rules.required}
              label="Registro Patronal"
              hasFeedback
            >
              <Select
                dataSource={registrosPatronales}
                labelProp="numero_registro_patronal"
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="salario_base_cotizacion_imss"
              // rules={rules.required}
              label="Salario Base de Cotización"
              hasFeedback
            >
              <Input
                allowClear
                disabled={isBlocked}
                maxLength={11}
                rules={rules.required}
                inputMode="decimal"
                pattern="^\d+(\.\d{0,2})?$"
                onChange={(e) => {
                  // Solo permite números y máximo dos decimales
                  let value = e.target.value.replace(/[^0-9.]/g, '');
                  // Solo un punto decimal
                  const parts = value.split('.');
                  if (parts.length > 2) {
                    value = `${parts[0]}.${parts.slice(1).join('')}`;
                  }
                  // Limita a dos decimales
                  if (parts[1]?.length > 2) {
                    value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                  }
                  formFiliacion.setFieldsValue({ salario_base_cotizacion_imss: value });
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="3. Ubicación Fiscal"
        extra="Código Postal, Estado Y Municipio Para El SAT"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Código Postal Fiscal" required style={{ marginBottom: 0 }}>
              <Form.Item
                name="codigo_postal_fiscal_texto_libre"
                noStyle
                rules={rules.required}
              >
                <Input
                  style={{ flex: 1, marginRight: 8 }}
                  maxLength={5}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value.length === 5) getFromPostalCode(value);
                  }}
                />
              </Form.Item>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item name="estado" label="Estado" hasFeedback>
              <Input allowClear disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="municipio"
              label="Municipio"
              hasFeedback
            >
              <Input
                allowClear
                disabled
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="preferencia_partidaria"
              label="Referencia"
              hasFeedback
            >
              <Select
                dataSource={preferenciaPartidaria}
                labelProp="descripcion"
                keyProp="id"
                disabled={isBlocked}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      {mensajeVisible && (
        <div style={{
          marginTop: '20px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '5px',
        }}
        >
          <p>
            Para corroborar que el RFC y el CURP generados son correctos,
            le sugerimos verificarlo en los siguientes enlaces:
          </p>
          <ul>
            <li>
              <span style={{ color: 'black' }}>RFC::</span>
              {' '}
              <a href="https://agsc.siat.sat.gob.mx/PTSC/ValidaRFC/index.jsf" target="_blank" rel="noopener noreferrer">https://agsc.siat.sat.gob.mx/PTSC/ValidaRFC/index.jsf</a>
            </li>
            <li>
              <span style={{ color: 'black' }}>CURP:</span>
              {' '}
              <a href="https://www.gob.mx/curp/" target="_blank" rel="noopener noreferrer">https://www.gob.mx/curp/</a>
            </li>
          </ul>
        </div>
      )}

    </Form>
  );
};

export default BecarioFiliacion;
